import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { getTranslatedMenuItem } from './get-translated-menu-item';

export function getTranslatedMenuItems(
  menuItems: MenuItem[],
  translateService: TranslateService,
  replaceWithPathById?: Record<string, string>,
  replaceWithLabelById?: Record<string, string>,
): MenuItem[] {
  return menuItems.map((menuItem) => {
    return getTranslatedMenuItem(
      menuItem,
      translateService,
      replaceWithPathById,
      replaceWithLabelById,
    );
  });
}
